export const timeClocksRoute = '/time-clocks';
export const staffTimeClocksRoute = '/staff-time-clocks';
export const newStaffTimeClocksRoute = '/staff-time-clocks/new';
